import script from "./config-row.vue?vue&type=script&lang=jsx"
export * from "./config-row.vue?vue&type=script&lang=jsx"

import "./config-row.vue?vue&type=style&index=0&id=3a6aa86c&lang=scss"

const __exports__ = script;

export default __exports__